module.exports = __webpack_public_path__ + "img/caboverde.3c842e86.svg";